module.exports = __webpack_public_path__ + "static/media/door06.6dedda05.png";